if(Modernizr.mq('only screen and (min-width: 1023px)')){
  require("./modules/animations");
}

require("../../bower_components/picturefill/dist/picturefill.min.js");

(function($){
  "use strict";

  var $window = $(window);

  var homeDiagram = require("./modules/homediagram"),
      equalHeight = require("./modules/equalHeightColumns"),
      gmaps = require("./modules/gmaps.js");

  $window.on("resize", function(){
    if($(".home-diagram-layout").length > 0){
      homeDiagram($(".home-diagram-layout"));
      Waypoint.refreshAll();
    }
    equalHeight($(".-is-equal-height"));
  }, 300);

  $window.trigger("resize");

  new Waypoint({
    element: $('body'),
    offset: "-100",
    handler: function(){
      $(".header").toggleClass("-is-active");
    }
  });

  $(".type-scrollindicator").on("click", function(){
    $('html, body').animate({
      scrollTop: $(window).height()
    }, 1000);
  });

  if($("#validation-form").length > 0){
    $("#validation-form").parsley();
  }

  $("#header-menu-toggle").on("click", function(){
    $(".header-menu").stop().slideToggle(300);
  });

  if($("#gmaps-target").length > 0){
    var lat = $("#gmaps-target").data("lat"),
        long = $("#gmaps-target").data("long"),
        map = gmaps([[lat, long]], [lat, long]);
  }

})(jQuery);



/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/main.js
 ** module id = 0
 ** module chunks = 1
 **/